import { createContext } from 'react';
import { GetAccountsDocumentsParams } from '@goldwasserexchange/actor/rest-services';

export const accountsDocumentsParamsContext = createContext<Partial<GetAccountsDocumentsParams>>({});
